import styled from "styled-components";
import { Grey, DarkGrey, White, Blue, Pink } from "./colors";

export const ProPic = styled.img`
  height: 80px;
  width: 80px;
  border-radius: 50%;
  border: 3px solid ${(props) => props.$borderColor || Grey};
  object-fit: cover;
`;

export const SecPic = styled.div`
  height: 80px;
  width: 80px;
  font-size: 20px;
  border-radius: 50%;
  border: 3px solid ${(props) => props.$borderColor || Grey};
  background-color: ${DarkGrey};
  display: flex;
  text-align: center;
  justify-content: center;
  align-items: center;
  color: ${White};
  text-transform: uppercase;
`;

export const ProPicSm = styled.img`
  height: 60px;
  width: 60px;
  margin-left: 20px;
  border-radius: 50%;
  border: 3px solid ${(props) => props.$borderColor || Grey};
  object-fit: cover;
`;

export const SecPicSm = styled.div`
  height: 60px;
  width: 60px;
  min-height: 60px;
  min-width: 60px;
  margin-left: 20px;
  border-radius: 50%;
  border: 3px solid ${(props) => props.$borderColor || Grey};
  background-color: ${DarkGrey};
  display: flex;
  text-align: center;
  justify-content: center;
  align-items: center;
  color: ${White};
  text-transform: uppercase;
  flex-shrink: 0;
  box-sizing: border-box;
`;

export const PlaceholderCircle = styled.div`
  height: 70px;
  width: 70px;
  border-radius: 50%;
  border: 3px dotted ${(props) => props.$borderColor || Grey};
  display: flex;
  text-align: center;
  justify-content: center;
  align-items: center;
`;

// Gradient border components specifically for Profile and PublicProfile pages
const GradientBorderWrapper = styled.div`
  height: 108px;
  width: 108px;
  border-radius: 50%;
  background: linear-gradient(135deg, ${Pink}, ${Blue});
  padding: 3px;
  display: inline-block;
`;

const ProPicGradientInner = styled.img`
  height: 101px;
  width: 101px;
  border-radius: 50%;
  object-fit: cover;
  display: block;
`;

const SecPicGradientInner = styled.div`
  height: 101px;
  width: 101px;
  font-size: 20px;
  border-radius: 50%;
  background-color: ${DarkGrey};
  display: flex;
  text-align: center;
  justify-content: center;
  align-items: center;
  color: ${White};
  text-transform: uppercase;
`;

export const ProPicGradient = ({ src, ...props }) => (
  <GradientBorderWrapper>
    <ProPicGradientInner src={src} {...props} />
  </GradientBorderWrapper>
);

export const SecPicGradient = ({ children, ...props }) => (
  <GradientBorderWrapper>
    <SecPicGradientInner {...props}>{children}</SecPicGradientInner>
  </GradientBorderWrapper>
);
